
let routes = {
    "assetsDir": "/",
    "compareProducts": "/ajax/compareProducts.json",
    "clearCompareProducts": "/ajax/clearCompareProducts.json",
    "pageCompare": "/ajax/pageCompare.json",
};

try{

    let routesLocal = require("./routes.local.js").default;

    routes = Object.assign(routes, routesLocal);

}catch(e) {

    console.log("Default routes applied");
}

export default routes;




